<template>
    <div>
        <b-card>
            <p><b>Configuration</b></p>

            <p>Activer <b-checkbox style="display: inline" v-model="activate"></b-checkbox></p>

            <div v-show="activate">
                <p>Type
                    <b-select v-model="type" :options="options"></b-select>
                </p>

                <div v-if="type == 'images' || type == 'videos'">
                    <p>Colonne de recherche
                        <b-input v-model="column_search"></b-input>
                    </p>

                    <p>Colonne de filtres
                        <b-input v-model="column_filter"></b-input>
                    </p>

                    <p>Colonne de résultats
                        <b-input v-model="column_result"></b-input>
                    </p>

                    <p>Colonne de sélection
                        <b-input v-model="column_select"></b-input>
                    </p>

                    <actionBuilder :projects_obj="projects_obj" :delete_option="false" :projects="projects" ref="actionBuilder"></actionBuilder>
                </div>
                <div v-else-if="type">
                    <p>Nom de l'élément de la bibliothèque
                        <b-input v-model="library_element_name"></b-input>
                    </p>
                </div>
            </div>
        </b-card>
    </div>

</template>

<script>

    import actionBuilder from "./actionBuilder.vue";

    export default {
        name: "confiurationBuilder",
        components: {
            actionBuilder
        },
        props: {
            projects: {},
            projects_obj: {}
        },
        data: function () {
            return {
                activate: false,

                type: "",
                column_search: "",
                column_filter: "",
                column_result: "",
                column_select: "",
                library_element_name: "",

                options: [
                    { text: "Images", value: "images" },
                    { text: "Vidéos", value: "videos" },
                    { text: "Règles", value: "rules" },
                    { text: "Chatgpt", value: "chatgpt" }
                ]
            };
        },
        methods: {
            async load(data)
            {
                var self = this;

                this.activate = data.activate;

                this.type = data.type || "";
                this.column_search = data.column_search || "";
                this.column_filter = data.column_filter || "";
                this.column_result = data.column_result || "";
                this.column_select = data.column_select || "";
                this.library_name = data.library_name || "";

                if (data && data.actions && this.$refs.actionBuilder)
                    await this.$refs.actionBuilder.load(data.actions);
            },
            async save()
            {
                return {
                    type: this.type,
                    activate: this.activate,
                    actions: this.$refs.actionBuilder ? await this.$refs.actionBuilder.save() : [],
                    column_search: this.column_search,
                    column_filter: this.column_filter,
                    column_result: this.column_result,
                    column_select: this.column_select,
                    library_element_name: this.library_element_name
                }
            }
        },
        mounted: function () {

        },
    }


</script>